// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"283":"6cb02af6","309":"8b414bc8","674":"b98ed78c"}[chunkId] + ".chunk.js");